(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vetta-gallery-triggers"] && !Shopify.designMode) return;
  try {
    (() => {
  const states = new WeakMap();
  const sizes = new Set(['A4 Personalisiert', 'A3 Premium', 'A4 Standard', 'A4 Personalisierter Hintergrund', 'A3 Rahmen + personalisierter Hintergrund']);
  const colors = new Set(['Kyalami Grün', 'Nardo Grau', 'Tango Rot', 'Orange', 'Schwarz', 'Nardo-Grau', 'Selenite Grau', 'Isle of Man - Green', 'Diamant-Weiß']);
  const pickerSelector = 'variant-selects, .globo-swatch-product-detail';

  function mediaKey(value) {
    return String(value || '').split('-').pop();
  }

  function refreshGallery(state) {
    state.gallery.elements?.viewer?.resetPages?.();
    state.gallery.elements?.thumbnails?.resetPages?.();
  }

  function itemKey(item) {
    const target = item.dataset?.mediaId || item.dataset?.target || item.querySelector?.('[data-media-id], [data-target]')?.dataset?.mediaId || item.querySelector?.('[data-target]')?.dataset?.target;
    return mediaKey(target);
  }

  function orderMediaKeys(state, keys) {
    if (!keys.length) return;
    const lists = [
      state.gallery.querySelector('[id^="GalleryViewer"]'),
      state.gallery.querySelector('[id^="GalleryThumbnails"]')
    ];
    lists.forEach(list => {
      if (!list) return;
      const children = Array.from(list.children);
      keys.slice().reverse().forEach(key => {
        const item = children.find(child => itemKey(child) === mediaKey(key));
        if (item) list.prepend(item);
      });
    });
  }

  function orderSelectedModelSet(state) {
    orderMediaKeys(state, state.modelSetKeys);
  }

  function orderAudiVariantGallery(state) {
    if (!state.audi || state.modelId) return;
    const keys = [
      mediaKey(state.variantMediaId),
      ...Array.from(state.baseMedia)
    ].filter((key, index, all) => key && all.indexOf(key) === index);
    orderMediaKeys(state, keys);
  }

  function updateMediaItems(state) {
    const selectedKey = mediaKey(state.modelId);
    const selectedSet = new Set(state.modelSetKeys);
    const lifestyleKeys = new Set([
      ...Object.values(state.models),
      ...Object.values(state.modelSets).flat()
    ]);
    state.gallery.querySelectorAll('[data-media-id], [data-target]').forEach(item => {
      const key = mediaKey(item.dataset.mediaId || item.dataset.target);
      if (selectedSet.size) {
        const selected = selectedSet.has(key);
        item.classList.toggle('vetta-gallery-hidden', !selected);
        item.classList.toggle('vetta-model-media-selected', selected);
        item.classList.remove('vetta-lifestyle-selected');
        return;
      }
      item.classList.remove('vetta-model-media-selected');
      if (lifestyleKeys.has(key) && !state.baseMedia.has(key)) {
        const selected = Boolean(selectedKey && key === selectedKey);
        item.classList.toggle('vetta-gallery-hidden', !selected);
        item.classList.toggle('vetta-lifestyle-selected', selected);
        return;
      }
      const visible = state.baseMedia.has(key) || key === mediaKey(state.variantMediaId);
      item.classList.toggle('vetta-gallery-hidden', !visible);
      item.classList.remove('vetta-lifestyle-selected');
    });
    refreshGallery(state);
  }

  function addPreviewLinks(state) {
    const picker = state.productInfo.querySelector('.globo-swatch-product-detail') || state.productInfo.querySelector('variant-selects');
    if (!picker) return;
    const openGallery = () => {
      state.shouldScroll = true;
      scrollToGallery(state, true);
    };
    const strings = window.vettaGalleryStrings || {};
    const createLink = modifier => {
      const link = document.createElement('button');
      link.type = 'button';
      link.className = 'vetta-gallery-preview-link ' + modifier;
      link.textContent = strings.preview || 'Auswahl im Bild ansehen ↑';
      link.setAttribute('aria-label', strings.previewAria || 'Aktuelle Auswahl oben in der Bildergalerie ansehen');
      link.addEventListener('click', openGallery);
      return link;
    };
    const colorGroup = picker.querySelector('[data-option-index="1"]');
    if (colorGroup && !colorGroup.querySelector('.vetta-gallery-preview-link--color')) {
      colorGroup.append(createLink('vetta-gallery-preview-link--color'));
    }
    const sizeControl = Array.from(picker.querySelectorAll('input, select')).find(control => sizes.has(control.value));
    const sizeGroup = sizeControl?.closest('.swatch--gl, fieldset, .product-form__input, .selector-wrapper');
    if (sizeGroup && !sizeGroup.querySelector('.vetta-gallery-preview-link--sizes')) {
      const row = document.createElement('div');
      row.className = 'vetta-size-row';
      const note = document.createElement('p');
      note.className = 'vetta-size-price-note';
      note.textContent = strings.sizeNote || 'Preis steigt bei Wahl einer größeren Größe';
      row.append(note, createLink('vetta-gallery-preview-link--sizes'));
      sizeGroup.append(row);
    }
  }

  function markSizeGroups(state) {
    state.productInfo.querySelectorAll(pickerSelector).forEach(picker => {
      picker.querySelectorAll('input, select').forEach(control => {
        if (!sizes.has(control.value)) return;
        const group = control.closest('.swatch--gl, fieldset, .product-form__input, .selector-wrapper');
        group?.classList.add('vetta-size-picker-group');
      });
    });
    addPreviewLinks(state);
  }

  function scrollToGallery(state, immediate) {
    if (!state.shouldScroll) return;
    state.shouldScroll = false;
    cancelAnimationFrame(state.scrollFrame);
    const doScroll = () => {
      if (!state.gallery.isConnected) return;
      const active = state.gallery.querySelector('[id^="GalleryViewer"] [data-media-id].is-active');
      const destination = active || state.gallery;
      state.gallery.preventStickyHeader?.();
      const header = document.querySelector('.section-header');
      const headerHeight = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position)
        ? header.getBoundingClientRect().height : 0;
      const top = Math.max(0, destination.getBoundingClientRect().top + window.scrollY - headerHeight - 12);
      window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    if (immediate) {
      doScroll();
    } else {
      state.scrollFrame = requestAnimationFrame(() => {
        state.scrollFrame = requestAnimationFrame(doScroll);
      });
    }
  }

  function findState(element) {
    const productInfo = element.closest('product-info');
    const gallery = productInfo?.querySelector('media-gallery');
    if (!gallery) return null;
    if (states.has(gallery)) return states.get(gallery);
    const config = gallery.querySelector('[data-vetta-gallery-models]');
    if (!config || typeof gallery.setActiveMedia !== 'function') return null;
    const settings = JSON.parse(config.textContent);
    const defaultSet = settings.modelSets?.[settings.defaultModel] || [];
    const defaultMedia = defaultSet[0] || settings.models[settings.defaultModel];
    const state = {
      gallery,
      productInfo,
      audi: Boolean(settings.audi),
      models: settings.models,
      modelSets: settings.modelSets || {},
      modelSetKeys: [...defaultSet],
      baseMedia: new Set(settings.baseMedia),
      modelId: productInfo.dataset.section + '-' + defaultMedia,
      variantMediaId: null,
      galleryNavigation: false,
      galleryNavigationTimer: 0,
      shouldScroll: false,
      scrollFrame: 0,
      repairFrame: 0,
      lastKey: '',
      lastTime: 0
    };
    const original = gallery.setActiveMedia.bind(gallery);
    state.activate = (id, prepend = false) => {
      const target = state.modelId && !state.galleryNavigation ? state.modelId : id;
      if (!gallery.querySelector('[id^="GalleryViewer"] [data-media-id="' + CSS.escape(target) + '"]')) return;
      const key = mediaKey(target);
      if (!state.modelId && !state.baseMedia.has(key)) state.variantMediaId = target;
      updateMediaItems(state);
      original(target, state.modelId && !state.galleryNavigation ? true : prepend);
      orderAudiVariantGallery(state);
      updateMediaItems(state);
    };
    gallery.setActiveMedia = state.activate;
    new MutationObserver(() => {
      if (!gallery.isConnected) return;
      cancelAnimationFrame(state.repairFrame);
      state.repairFrame = requestAnimationFrame(() => updateMediaItems(state));
    }).observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    new MutationObserver(() => markSizeGroups(state)).observe(productInfo, { childList: true, subtree: true });
    states.set(gallery, state);
    productInfo.classList.remove('vetta-color-chosen');
    gallery.dataset.vettaManualVariantScroll = 'true';
    markSizeGroups(state);
    orderSelectedModelSet(state);
    state.activate(state.modelId, true);
    return state;
  }

  function release(state) {
    if (!state) return;
    state.modelId = null;
    state.modelSetKeys = [];
    state.variantMediaId = null;
    state.galleryNavigation = false;
    state.shouldScroll = false;
    delete state.gallery.dataset.vettaScrollOnSelection;
    cancelAnimationFrame(state.scrollFrame);
    cancelAnimationFrame(state.repairFrame);
    clearTimeout(state.galleryNavigationTimer);
    updateMediaItems(state);
  }

  function handleSelection(event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const picker = event.target.closest(pickerSelector);
    if (!picker) return;
    const label = event.target.closest('label[for]');
    const control = label ? document.getElementById(label.htmlFor) : event.target.closest('input, select');
    if (!control || control.disabled || !picker.contains(control)) return;
    if (event.type === 'click' && control.tagName === 'SELECT') return;
    if (event.type === 'change' && control.tagName !== 'SELECT') return;
    const state = findState(picker);
    if (!state) return;
    const value = control.value;
    const model = state.models[value];
    const size = sizes.has(value);
    if (!model && !size && !colors.has(value)) return;
    const key = control.name + ':' + value;
    if (state.lastKey === key && performance.now() - state.lastTime < 100) return;
    const selectedModel = state.productInfo.querySelector('.globo-swatch-product-detail [data-option-index="0"] input:checked')?.value;
    release(state);
    state.lastKey = key;
    state.lastTime = performance.now();
    state.shouldScroll = Boolean(model);
    if (state.shouldScroll) state.gallery.dataset.vettaScrollOnSelection = 'true';
    if (model) {
      const modelSet = state.modelSets[value] || [];
      const firstMedia = modelSet[0] || model;
      state.productInfo.classList.remove('vetta-color-chosen');
      state.modelSetKeys = [...modelSet];
      state.modelId = state.productInfo.dataset.section + '-' + firstMedia;
      orderSelectedModelSet(state);
      state.activate(state.modelId);
      scrollToGallery(state);
      return;
    }
    if (colors.has(value)) {
      state.productInfo.classList.add('vetta-color-chosen');
      markSizeGroups(state);
    }
    requestAnimationFrame(() => {
      if (state.lastKey !== key || state.modelId) return;
      const id = state.productInfo.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const json = state.productInfo.querySelector('#vettaVariantsData');
      const variants = json ? JSON.parse(json.textContent) : [];
      const variant = variants.find(item => String(item.id) === String(id));
      if (variant?.options.includes(value) && variant.featured_media?.id) {
        state.activate(state.productInfo.dataset.section + '-' + variant.featured_media.id);
      }

    });
  }

  document.addEventListener('click', handleSelection, true);
  document.addEventListener('change', handleSelection, true);
  for (const type of ['pointerdown', 'keydown', 'touchstart']) {
    document.addEventListener(type, event => {
      if (!event.isTrusted || !(event.target instanceof Element)) return;
      const gallery = event.target.closest('media-gallery');
      const state = gallery && states.get(gallery);
      if (!state?.modelId) return;
      state.galleryNavigation = true;
      clearTimeout(state.galleryNavigationTimer);
      state.galleryNavigationTimer = setTimeout(() => {
        state.galleryNavigation = false;
      }, 1000);
    }, { capture: true, passive: true });
  }

  function initialize() {
    const configs = document.querySelectorAll('[data-vetta-gallery-models]');
    if (!configs.length) return;
    document.documentElement.classList.add('vetta-pdp-horizontal-lock');
    document.body?.classList.add('vetta-pdp-horizontal-lock');
    configs.forEach(findState);
  }

  customElements.whenDefined('media-gallery').then(initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vetta-pdp-plate-us"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-vetta-us-plate]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const stateInput = document.getElementById('vettaUsState');
  const plateInput = document.getElementById('vettaUsPlateNumber');
  const fileInput = root.querySelector('[data-vetta-us-plate-file]');
  const fileNameEl = root.querySelector('[data-vetta-us-file-name]');

  fileInput.addEventListener('change', () => {
    fileNameEl.textContent = (fileInput.files && fileInput.files[0]) ? fileInput.files[0].name : 'No file selected';
  });

  function setProperty(form, name, value) {
    let input = form.querySelector('input[name="properties[' + name + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  // Attaches the current field values to the REAL add-to-cart form, wherever it lives in the DOM
  // (this widget's own block may render outside the <form> depending on block order — exactly the
  // reason the DE plate widget uses this same pattern instead of relying on native form nesting).
  function attachToForm() {
    const form = document.querySelector('form[action^="/cart/add"], product-form form');
    if (!form) return null;

    setProperty(form, 'License Plate State', stateInput.value || 'Not specified');
    setProperty(form, 'License Plate Number', plateInput.value || 'Not specified');

    if (fileInput.files && fileInput.files.length) {
      // A specialty-plate photo can only reach the order as a line item property through a real
      // (non-AJAX) multipart form post, and only if the file input is an actual descendant of the
      // submitted form. Relocating the node preserves its selected FileList.
      if (fileInput.parentNode !== form) {
        form.appendChild(fileInput);
      }
      form.setAttribute('enctype', 'multipart/form-data');
      const action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add.js') !== -1) {
        form.setAttribute('action', action.replace('/cart/add.js', '/cart/add'));
      }
    }
    return form;
  }

  document.addEventListener('click', event => {
    if (event.target.closest('button[name="add"], button[type="submit"]')) attachToForm();
  }, true);

  // Capture-phase listener on document: this always runs before any listener bound directly to the
  // form (Dawn's product-form.js, or this theme's fetch-based fast add-to-cart), because capture-phase
  // listeners on ancestors fire before the target's own listeners regardless of registration order.
  // When a file is attached we stop those faster AJAX paths from handling the submit at all and let
  // the browser perform a normal full-page multipart post instead, which is the only reliable way to
  // deliver an uploaded file as a line item property.
  document.addEventListener('submit', event => {
    const form = attachToForm();
    if (form && event.target === form && fileInput.files && fileInput.files.length) {
      event.stopImmediatePropagation();
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vetta-pdp-plate"] && !Shopify.designMode) return;
  try {
    (() => {
  const plate = document.querySelector('[data-vetta-plate]');
  if (!plate || plate.dataset.ready) return;
  plate.dataset.ready = 'true';
  const countryButtons = [...document.querySelectorAll('[data-vetta-country]')];
  const layouts = [...plate.querySelectorAll('[data-vetta-plate-layout]')];
  const parts = [...plate.querySelectorAll('[data-vetta-plate-part]')];
  let country = 'Deutschland';

  function cleanPart(input) {
    let value = input.value.toUpperCase();
    const part = input.dataset.vettaPlatePart;
    if(part === 'international') return;
    if (part === 'de-region' || part === 'de-letters' || part === 'ch-canton' || part === 'at-region') {
      value = value.replace(/[^A-ZÄÖÜ]/g, '');
    } else if (part === 'de-number' || part === 'ch-number') {
      value = value.replace(/[^0-9]/g, '');
    } else {
      value = value.replace(/[^A-ZÄÖÜ0-9 -]/g, '').replace(/\s+/g, ' ');
    }
    if (input.value !== value) input.value = value;
  }

  function selectedLayout() {
    return layouts.find(layout => layout.dataset.vettaPlateLayout === country) || layouts.find(layout => layout.dataset.vettaPlateLayout === 'International');
  }

  function plateValue() {
    const layout = selectedLayout();
    if (!layout) return '';
    const value = key => layout.querySelector('[data-vetta-plate-part="' + key + '"]')?.value.trim() || '';
    if (country === 'Deutschland') {
      const region = value('de-region');
      const letters = value('de-letters');
      const number = value('de-number');
      if (!region && !letters && !number) return '';
      return [region, letters].filter(Boolean).join('-') + (number ? ' ' + number : '');
    }
    if (country === 'Schweiz') {
      return [value('ch-canton'), value('ch-number')].filter(Boolean).join(' ');
    }
    if(country === 'Österreich')return [value('at-region'), value('at-number')].filter(Boolean).join(' ');
    return value('international');
  }

  function selectCountry(button) {
    country = button.dataset.vettaCountry;
    plate.dataset.country = country;
    if(countrySelect) countrySelect.value=country;
    layouts.forEach(layout => {
      layout.hidden = layout !== selectedLayout();
    });
    countryButtons.forEach(item => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
  }

  const countrySelect=document.getElementById('VettaCountrySelect'), search=document.getElementById('VettaCountrySearch');
  const names=new Intl.DisplayNames(['de'],{type:'region'});
  const countries='AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW XK'.split(' ').map(code=>({code,name:names.of(code),flag:[...code].map(c=>String.fromCodePoint(127397+c.charCodeAt(0))).join('')})).sort((a,b)=>a.name.localeCompare(b.name,'de'));
  function fillCountries(query=''){countrySelect.replaceChildren();countries.filter(c=>c.name===country || (c.name+' '+c.code+(c.code==='US'?' USA Amerika Vereinigte Staaten':'')).toLowerCase().includes(query.toLowerCase())).forEach(c=>{const option=document.createElement('option');option.value=c.name;option.textContent=c.flag+' '+c.name;option.selected=c.name===country;countrySelect.appendChild(option);});}
  fillCountries();
  search?.addEventListener('input',()=>fillCountries(search.value));
  countrySelect.addEventListener('change',()=>{selectCountry({dataset:{vettaCountry:countrySelect.value}});const selected=countries.find(c=>c.name===country);plate.querySelector('[data-vetta-international-flag]').textContent=selected?.flag||'🌐';});
  countryButtons.forEach(button => button.addEventListener('click', () => selectCountry(button)));
  parts.forEach(input => input.addEventListener('input', () => cleanPart(input)));

  function setProperty(form, name, value) {
    let input = form.querySelector('input[name="properties[' + name + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  function attachToForm() {
    const form = plate.closest('form') || document.querySelector('form[action^="/cart/add"], product-form form');
    if (!form) return;
    setProperty(form, 'Kennzeichen', plateValue() || 'Kein Kennzeichen angegeben');
    setProperty(form, 'Kennzeichen-Land', country);
  }

  document.addEventListener('submit', event => {
    if (event.target.matches('form[action^="/cart/add"]') || event.target.closest('product-form')) attachToForm();
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('button[name="add"], button[type="submit"]')) attachToForm();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
